(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["infinity-card-tags"] && !Shopify.designMode) return;
  try {
    (() => {
    if (!window.customElements || customElements.get('infinity-care-tags')) return;
    if (!window.ResizeObserver || !window.HTMLDialogElement || !HTMLDialogElement.prototype.showModal) return;

    let sharedDialog;
    let dialogOpener;

    function getDialog() {
      if (sharedDialog) return sharedDialog;
      const dialog = document.createElement('dialog');
      dialog.className = 'inf-care-dialog';
      dialog.id = 'infinity-care-concerns-dialog';
      dialog.setAttribute('aria-labelledby', 'infinity-care-concerns-heading');
      dialog.setAttribute('aria-describedby', 'infinity-care-concerns-product');
      // Static markup only. Product names and labels are assigned as text below.
      dialog.innerHTML = `
        <span class="inf-care-dialog__brand" dir="ltr">INFINITY CARE</span>
        <button class="inf-care-dialog__close" type="button" autofocus aria-label="Close">&times;</button>
        <h2 class="inf-care-dialog__heading" id="infinity-care-concerns-heading"></h2>
        <p class="inf-care-dialog__product" id="infinity-care-concerns-product"></p>
        <nav class="inf-care-dialog__links"></nav>`;
      document.body.appendChild(dialog);
      dialog.querySelector('button').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => {
        if (dialogOpener && dialogOpener.isConnected && !dialogOpener.hidden) dialogOpener.focus({ preventScroll: true });
        dialogOpener = null;
      });
      sharedDialog = dialog;
      return dialog;
    }

    class InfinityCareTags extends HTMLElement {
      connectedCallback() {
        this.connectFrame = requestAnimationFrame(() => this.connect());
      }

      connect() {
        if (!this.isConnected) return;
        this.rail = this.querySelector('.inf-card-tags__rail');
        this.links = Array.from(this.querySelectorAll('.inf-card-tags__link'));
        this.more = this.querySelector('.inf-card-tags__more');
        if (!this.rail || !this.more || !this.links.length) return;

        this.onClick = (event) => {
          const target = event.target.closest('.inf-card-tags__link, .inf-card-tags__more');
          if (!target) return;
          // Preserve the native link action, including Ctrl/Cmd-click.
          event.stopPropagation();
          if (target === this.more) this.openConcerns();
        };
        this.addEventListener('click', this.onClick);
        this.onFont = () => this.queueFit();
        this.observer = new ResizeObserver(() => this.queueFit());
        this.observer.observe(this.rail);
        if (document.fonts) {
          document.fonts.ready.then(() => this.queueFit());
          document.fonts.addEventListener('loadingdone', this.onFont);
        }
        this.fit();
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.connectFrame);
        cancelAnimationFrame(this.fitFrame);
        if (this.observer) this.observer.disconnect();
        if (this.onClick) this.removeEventListener('click', this.onClick);
        if (document.fonts && this.onFont) document.fonts.removeEventListener('loadingdone', this.onFont);
        if (dialogOpener === this.more && sharedDialog && sharedDialog.open) sharedDialog.close();
      }

      queueFit() {
        cancelAnimationFrame(this.fitFrame);
        if (this.isConnected) this.fitFrame = requestAnimationFrame(() => this.fit());
      }

      fit() {
        // Use layout widths; carousel transforms do not change available space.
        const available = this.rail.clientWidth;
        if (!available) return;
        const active = document.activeElement;
        this.removeAttribute('data-summary');
        this.links.forEach((link) => { link.hidden = false; link.style.maxWidth = ''; });
        this.more.hidden = false;
        const widths = this.links.map((link) => link.offsetWidth);
        const gap = parseFloat(getComputedStyle(this.rail).columnGap) || 6;
        const moreWidth = this.more.offsetWidth;
        const limit = Math.max(1, Number(this.dataset.visibleLimit) || 2);
        const total = this.links.length;
        let visible = Math.min(total, limit);
        while (visible > 0) {
          const inlineWidth = widths.slice(0, visible).reduce((sum, width) => sum + width, 0);
          const extraWidth = visible < total ? gap + moreWidth : 0;
          if (inlineWidth + gap * (visible - 1) + extraWidth <= available) break;
          visible -= 1;
        }
        // At very narrow widths, offer the complete chooser without cutting a label.
        if (!visible) this.setAttribute('data-summary', '');
        this.links.forEach((link, index) => { link.hidden = index >= visible; });
        const remaining = total - visible;
        this.more.hidden = remaining === 0;
        this.more.querySelector('bdi').textContent = '+' + remaining;
        const label = this.dir === 'rtl' ? 'تصنيفات العناية' : (visible ? 'more concerns' : 'care concerns');
        this.more.setAttribute('aria-label', remaining + ' ' + label + ' — ' + this.dataset.productTitle);
        this.setAttribute('data-enhanced', '');
        if (active && this.contains(active) && active.hidden) {
          (this.more.hidden ? this.links[0] : this.more).focus({ preventScroll: true });
        }
      }

      openConcerns() {
        const dialog = getDialog();
        const isArabic = this.dir === 'rtl';
        dialog.dir = this.dir;
        dialog.style.fontFamily = getComputedStyle(this).fontFamily;
        dialog.querySelector('h2').textContent = this.getAttribute('aria-label');
        dialog.querySelector('p').textContent = this.dataset.productTitle;
        dialog.querySelector('button').setAttribute('aria-label', isArabic ? 'إغلاق' : 'Close');
        const list = dialog.querySelector('nav');
        list.setAttribute('aria-label', this.getAttribute('aria-label'));
        list.replaceChildren(...this.links.map((source) => {
          const link = source.cloneNode(true);
          link.hidden = false;
          link.removeAttribute('style');
          link.className = 'inf-care-dialog__link';
          link.querySelector('.inf-card-tags__text').textContent = source.dataset.fullLabel;
          return link;
        }));
        dialogOpener = this.more;
        this.more.setAttribute('aria-controls', dialog.id);
        dialog.showModal();
      }
    }

    customElements.define('infinity-care-tags', InfinityCareTags);
  })();
  } catch(e) { console.error(e); }
})();

})();
